import { createTypes } from '../../utils/helpers';

export const REGIONS_CLEAR_COUNTRIES = 'REGIONS_CLEAR_COUNTRIES';
const REGIONS_FETCH_STATES: any = createTypes('REGIONS_FETCH_STATES');
const REGIONS_FETCH_COUNTRIES: any = createTypes('REGIONS_FETCH_COUNTRIES');
const REGIONS_FETCH_REGIONS: any = createTypes('REGIONS_FETCH_REGIONS');
const REGIONS_FETCH_GLOBAL_COUNTRIES: any = createTypes(
  'REGIONS_FETCH_GLOBAL_COUNTRIES',
);
const REGIONS_FETCH_CATEGORY: any = createTypes('REGIONS_FETCH_CATEGORY');

export {
  REGIONS_FETCH_REGIONS,
  REGIONS_FETCH_STATES,
  REGIONS_FETCH_COUNTRIES,
  REGIONS_FETCH_GLOBAL_COUNTRIES,
  REGIONS_FETCH_CATEGORY,
};
